import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { UIHeading3 } from '@cian/ui-kit';

import { selectAnalyticsOfferStatus, selectAnalyticsProduct } from '../../../../../../selectors/analytics';
import { selectTermsDurations, selectTermsDuration } from '../../../../../../selectors/termsDurations';
import { setTermsDuration } from '../../../../../../actions/termsDurations';
import { Slider } from '../../../../../common/Slider';
import { TERMS_DURATIONS_SLIDER_ID } from '../../../../../../constants/nodeIds';

import { SLIDE_WIDTH, INDENTS } from './constants';
import { getActiveDurationIdx } from './utils';
import { trackShowDurations, trackDurationClick } from './tracking';
import { Duration } from './Duration';
import * as styles from './TermsDurations.css';

export const TermsDurationsContainer = () => {
  const dispatch = useDispatch();

  const durations = useSelector(selectTermsDurations);
  const selectedDurationInDays = useSelector(selectTermsDuration);
  const analyticsOfferStatus = useSelector(selectAnalyticsOfferStatus);
  const { id, variant } = useSelector(selectAnalyticsProduct);

  const setDuration = React.useCallback(
    ({ durationInDays, discountPercent }) => {
      dispatch(setTermsDuration(durationInDays));
      trackDurationClick({
        discount: discountPercent,
        days: durationInDays,
        analyticsOfferStatus,
        form_id: id as number,
        vas: variant as string,
      });
    },
    [dispatch, analyticsOfferStatus, id, variant],
  );

  React.useEffect(() => {
    trackShowDurations({
      analyticsOfferStatus,
      form_id: id as number,
      vas: variant as string,
    });
  }, []);

  return (
    <div className={styles['wrapper']}>
      <UIHeading3>Срок продвижения</UIHeading3>

      <div className={styles['durations']}>
        <Slider
          id={TERMS_DURATIONS_SLIDER_ID}
          visibleSlides={durations.length}
          initialSlide={getActiveDurationIdx(durations, selectedDurationInDays)}
          slideWidth={SLIDE_WIDTH}
          indents={INDENTS}
        >
          {durations.map(({ durationInDays, discountPercent }, i) => (
            <Duration
              key={i}
              duration={durationInDays}
              discount={discountPercent}
              checked={selectedDurationInDays === durationInDays}
              onClick={() => setDuration({ durationInDays, discountPercent })}
            />
          ))}
        </Slider>
      </div>
    </div>
  );
};
